import React from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import FormInput from "../../../utils/FormInput";
import { FormElementModel } from "../../models/FormElementModel";
import { guardianRegisterForm } from "./inputsForm/InputGuardianFormModels";
import { useSelector } from "react-redux";
import { State } from "../../store";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";
import EADivider from "../shared/EADivider";
import ConsentInputs from "../FinalizePage/ConsentInputs/ConsentInputs";
import EAAlert from "../shared/EAAlert";
import GuardianCheckboxes from "./GuardianCheckboxes";

export type GuardianInputs = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  repeatPassword: string;
  phone: string;
  acceptEAktywni: boolean;
  acceptStatute: boolean;
  allowMailing: boolean;
  guardianDeclaration: boolean;
  newsletterAgreement: boolean;
  // Opcjonalne checkboxy specyficzne dla facilityId
  acceptRegulaminKS?: boolean;
};

interface IProps {
  onSubmit: (data: GuardianInputs) => void;
}

const GuardianStep: React.FC<IProps> = ({ onSubmit }) => {
  const { t } = useTranslation();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const alertLogin = useSelector((state: State) => state.alerts.errors);

  const {
    register,
    watch,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm<GuardianInputs>({
    defaultValues: {
      acceptEAktywni: false,
      acceptStatute: false,
      allowMailing: false,
      guardianDeclaration: false,
      newsletterAgreement: false,
    },
  });

  const handleGuardianSubmit: SubmitHandler<GuardianInputs> = (data) => {
    onSubmit(data);
  };

  return (
    <>
      <h4 className="section-title">{t("dane_opiekuna")}</h4>

      <form onSubmit={handleSubmit(handleGuardianSubmit)}>
        <div className="flex-start-center flex-wrap">
          {guardianRegisterForm(watch, register).map((item: FormElementModel, index: number) => (
            <FormInput key={index} {...item} errors={errors} />
          ))}
        </div>

        <ConsentInputs errors={errors} control={control} setValue={setValue} />

        <GuardianCheckboxes errors={errors} control={control} />

        {alertLogin && typeof alertLogin === "string" && alertLogin !== "Użytkownik nie jest zalogowany" && (
          <EAAlert message={alertLogin} type="error" />
        )}

        <EADivider />

        <div className="flex-center-center">
          <EAButton title={t("przejdz_dalej_i_wprowadz_uczestnikow")} inputType="submit" fullWidth />
        </div>

        {saleConfiguration.message_createNewAccount && saleConfiguration.message_createNewAccount.length > 3 && (
          <EAAlert message={saleConfiguration.message_createNewAccount} type="warning" dangerouslySetInnerHTML />
        )}
      </form>
    </>
  );
};

export default GuardianStep;

